import { useQuery } from "@tanstack/react-query";
import { authManager } from "src/main";

export const useGraphToken = () => {
  return useQuery({
    queryKey: ["graphToken", authManager.providerLoginResult.idTokenClaims.oid],
    queryFn: () => authManager.microsoftAuth?.fetch_graph_token(),
  });
};
